import { useState } from "react";
import "./media.css";
import { toast } from "react-toastify";
import ApiRequest from "../../helper/ApiRequest";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const addMediaEndPoints = ApiEndpoints.adminMedia.adminMediaCreate;

export default function AddMedia() {
  const navigate = useNavigate();
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [data, setData] = useState(
    {
      title: "",
      link: "",
      thumbnail_image: null,
      logo: null,
      created_by: "admin",
      createdAt: new Date().toISOString(),
    }
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Prevent spaces in the `link` field
    if (name === "link") {
      const filteredValue = value.replace(/\s/g, ""); // Remove spaces
      setData((prevData) => ({
        ...prevData,
        [name]: filteredValue,
      }));
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle file input changes for image uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (name === "thumbnail_image") {
          setThumbnailPreview(reader.result);
        } else if (name === "logo") {
          setLogoPreview(reader.result);
        }
      };
      reader.readAsDataURL(file);

      setData((prevData) => ({
        ...prevData,
        [name]: file,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }

    try {
      const response = await ApiRequest("POST", addMediaEndPoints, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.error === true) {
        toast.error(response.message)
      } else {
        toast.success(response.message)
        navigate("/admin/media");
      }
    } catch (error) {
      toast.error(error)
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add Media</h5>
      </div>
      <div className="add-media-content">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Title */}
            <div className="col-md-12">
              <label>Title:*</label>
              <input
                name="title"
                required
                type="text"
                className="form-control"
                value={data.title}
                onChange={handleInputChange}
              />
            </div>

            {/* link Input */}
            <div className="col-md-12">
              <label>Link:*</label>
              <input
                name="link"
                required
                type="text"
                className="form-control"
                value={data.link}
                onChange={handleInputChange}
              />
            </div>


            {/* Date Input */}
            <div className="col-md-12">
              <label>Creation Date:*</label>
              <input
                name="createdAt"
                required
                type="date"
                className="form-control"
                value={data.createdAt.split("T")[0]} // Format the date for the 'date' input
                onChange={(e) => {
                  setData((prevData) => ({
                    ...prevData,
                    createdAt: e.target.value, // Keep the date in a format suitable for 'date' input
                  }));
                }}
              />
            </div>

            {/* card Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label>Thumbnail Image (510 x 400 px):*</label>
                <input
                  required
                  name="thumbnail_image"
                  type="file"
                  className="form-control"
                  onChange={handleFileChange}
                />
                {thumbnailPreview && (
                  <img
                    src={thumbnailPreview}
                    alt="Preview"
                    style={{ width: "100px", maxHeight: "300px", marginTop: "5px" }}
                  />
                )}
              </div>
            </div>

            {/* media logo Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="bannerImage">Media Logo (140 x 28 px):*</label>
                <input
                  name="logo"
                  type="file"
                  className="form-control"
                  required
                  onChange={handleFileChange}
                />

                {logoPreview && (
                  <img
                    src={logoPreview}
                    alt="Preview"
                    style={{ width: "100px", maxHeight: "300px", marginTop: "5px" }}
                  />
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                Add Media
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
